import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomerModel, CustomFeeModel, OrderCreateModel, OrderProductCreateModel } from '../../../../../shared/service-proxies/event-service-proxy';

@Component({
    selector: 'app-products-order-card',
    templateUrl: './products-order-card.component.html',
    styleUrls: ['./products-order-card.component.scss'],
    standalone: false
})
export class ProductsOrderCardComponent implements OnInit {
  @Input() order: OrderCreateModel = new OrderCreateModel();
  @Input() productsSelected: boolean = false;
  @Input() getTotalPrice!: (product: OrderProductCreateModel) => number;
  @Input() getOrderTotal!: () => number;
  @Input() shippingPrice!: number;

  @Input() requireShipping: boolean = false

  @Output() nextStep = new EventEmitter<void>();
  @Output() productsSelectedChange = new EventEmitter<boolean>();
  @Output() productRemoved = new EventEmitter<void>();
  @Output() dataCleared = new EventEmitter<boolean>(false);
  @Output() shippingPriceChange = new EventEmitter<number>();

  decorativeLineVisible: boolean = false;
  internalShippingPrice!: number;

  ngOnInit(): void {
    this.order.currency = 'usd';
  }

  ngOnChanges() {
    this.shippingPriceChange.emit(this.shippingPrice);
  }


  onQuantityChange(newQuantity: number, product: OrderProductCreateModel) {
    product.quantity = newQuantity;
  }

  changeShippingPrice(value: number) {
    this.shippingPrice = value;
    this.shippingPriceChange.emit(value);
  }

  removeProduct(productId: string) {
    this.order.products = this.order.products.filter(product => product.productId !== productId);
    this.updateProductsSelected();
    this.productRemoved.emit();
    this.productsSelectedChange.emit(this.order.products.length > 0);
  }

  clearAll() {
    this.order.products = [];
    this.productsSelected = false;
    this.updateProductsSelected();
    this.productRemoved.emit();
     this.dataCleared.emit();
  }

  openNextStep() {
    this.decorativeLineVisible = true;
    this.nextStep.emit();
  }

  private updateProductsSelected() {
    const hasProducts = this.order.products.length > 0;
    this.productsSelectedChange.emit(hasProducts); 
  }

}
